import { BaseRouteProps } from '../types/route-props';
import { IRelatedProductsResponse } from '../types/api/related-products-api';
import { AxiosRequestConfig, Method, callAxios } from '../axios';
import { getBrandName } from '../locale';

export const relatedProductsApiFetchers = {
  getRelatedProducts: async ({
    countryCode,
    languageCode,
    productId,
  }: BaseRouteProps & {
    productId: string;
  }) => {
    const GET_RELATED_PRODUCTS_URL = `/products/${productId}/related-products`;

    const requestSettings: AxiosRequestConfig<unknown> = {
      method: Method.GET,
      url: GET_RELATED_PRODUCTS_URL,
      params: {
        brand: getBrandName(),
        'country-code': countryCode,
        'language-code': languageCode,
      },
    };
    try {
      const response = await callAxios<IRelatedProductsResponse>(requestSettings);
      return { relatedProductsResponse: response.data, error: null };
    } catch (error) {
      return { relatedProductsResponse: null, error };
    }
  },
};
